import { gql } from '../../__generated__/gql'

export const CHECK_USER_PCO_TOKEN_QUERY = gql(`
  query checkUserPcoToken {
    pcoTokenCheck {
      status
      authUrl
    }
  }
`)
